var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.696 13.456C6.016 13.456 6.288 13.184 6.288 12.864V4.35201C6.288 4.03201 6.016 3.76001 5.696 3.76001C5.376 3.76001 5.104 4.03201 5.104 4.35201V12.864C5.104 13.184 5.36 13.456 5.696 13.456Z",
    fill: "#D32E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99972 13.456C8.31972 13.456 8.59172 13.184 8.59172 12.864V4.35201C8.59172 4.03201 8.31972 3.76001 7.99972 3.76001C7.67972 3.76001 7.40771 4.03201 7.40771 4.35201V12.864C7.40771 13.184 7.67972 13.456 7.99972 13.456Z",
    fill: "#D32E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3034 13.456C10.6234 13.456 10.8954 13.184 10.8954 12.864V4.35201C10.8954 4.03201 10.6234 3.76001 10.3034 3.76001C9.98343 3.76001 9.71143 4.03201 9.71143 4.35201V12.864C9.71143 13.184 9.98343 13.456 10.3034 13.456Z",
    fill: "#D32E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7917 1.536H10.3677L9.74372 0.656002C9.63172 0.496002 9.43972 0.400002 9.24772 0.400002H6.76772C6.57572 0.400002 6.38372 0.496002 6.27172 0.656002L5.64772 1.536H2.20772C1.88772 1.536 1.61572 1.808 1.61572 2.128C1.61572 2.448 1.88772 2.72 2.20772 2.72H2.67172V14.16C2.67172 14.944 3.31172 15.6 4.11172 15.6H11.9037C12.6877 15.6 13.3437 14.96 13.3437 14.16V2.72H13.8077C14.1277 2.72 14.3997 2.448 14.3997 2.128C14.3997 1.808 14.1117 1.536 13.7917 1.536ZM12.1437 14.16C12.1437 14.304 12.0317 14.416 11.8877 14.416H4.11172C3.96772 14.416 3.85572 14.304 3.85572 14.16V2.72H12.1437V14.16Z",
    fill: "#D32E2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e9f9384361eb2cb85d0f9d2181813520.svg";
export { ForwardRef as ReactComponent };